/**
 * Main App Component - FSS Calculator
 *
 * Purpose: Root component that orchestrates the FSS Calculator
 * Features: Context provider, step management, responsive layout
 */

import React from 'react';
import { CalculatorProvider, useCalculatorContext } from './contexts/CalculatorContext';
import StateSelector from './components/StateSelector';
import IndustrySelector from './components/IndustrySelector';
import ResultsDisplay from './components/ResultsDisplay';
import ProgressIndicator from './components/ProgressIndicator';
import './App.css';

/**
 * Calculator Content Component
 * Handles step-based rendering based on calculator state
 */
const CalculatorContent = () => {
  const { state } = useCalculatorContext();

  return (
    <div className="fss-root fss-app-container">
      {/* Progress Indicator - visible on all steps */}
      <div className="fss-progress-container">
        <ProgressIndicator />
      </div>

      {/* Main Content Area */}
      <main className="fss-app-main">
        <div className="fss-calculator-content">
          {/* Step 1: State Selection */}
          {state.currentStep === 1 && <StateSelector />}

          {/* Step 2: Industry Selection */}
          {state.currentStep === 2 && <IndustrySelector />}

          {/* Step 3: Results Display */}
          {state.currentStep === 3 && <ResultsDisplay />}
        </div>
      </main>
    </div>
  );
};

/**
 * Main App Component
 * Wraps the entire application with necessary providers
 */
function App() {
  return (
    <CalculatorProvider>
      <CalculatorContent />
    </CalculatorProvider>
  );
}

export default App;
